<template>
  <v-snackbar 
    top 
    right 
    app
    :value="!!message"
    :color="color"
    @input="closing"
  >
    {{text}}
  </v-snackbar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'TheNotifier',
  computed: {
    ...mapState('notify', [
      'message'
    ]),
    color () {
      return this.message ? this.message.type : 'primary'
    },
    text () {
      return this.message ? this.message.text : ''
    }
  },
  methods: {
    ...mapMutations('notify', [
      'setMessage'
    ]),
    /**
     * To avoid color glitch when closing
     */
    closing () {
      setTimeout(() => this.setMessage(null), 1000)
    }
  }
}
</script>